export const uidUrl = (url: string): string => v1Dict[url] || url;

export const v1Dict: Record<string, string> = {
  "/entities/search": "/v2/entities/search",
};

export const v2Dict: Record<string, string> = {
  "/entities": "/v2/entities",
  "/entities/iterator": "/v2/entities/iterator",
  "/entities/search": "/v3/entities/search",
};
